import SpecialsPage from 'src/dispensary/specials';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

SpecialsPage.layout = CoreMenuLayout;
export default SpecialsPage;
